<template>
  <div v-if="activeType === 'model_data' && selectedWidget.hookId">
    <div style="margin-top: 20px; ">Name Position</div>
    <SelectButton style="margin-bottom: 20px" v-model="labelPosition" :options="positionOptions"/>

    <div style="margin-top: 20px">Model Field</div>
    <SelectButton v-model="modelField" :options="modelFieldOptions"/>

    <div class="row-height-container" v-if="modelField === 'Notes' || modelField === 'Source' || modelField === 'Message'">
      <div style="margin-top: 20px">Row Height</div>
    <InputNumber v-model="textAreaRows" showButtons buttonLayout="horizontal" :min="1" :max="99">
      <template #incrementbuttonicon>
        <span class="pi pi-plus" />
      </template>
      <template #decrementbuttonicon>
        <span class="pi pi-minus" />
      </template>
    </InputNumber>
    </div>
    <div class="row-height-placeholder" v-else-if="modelField !== 'Notes' && modelField !== 'Source' && modelField !== 'Message'">
    </div>

    <div v-if="activeSubtype === 'out_text'">
      <Checkbox v-model="selectedWidget.compact" :binary="true" style="margin-right: 10px;margin-top: 10px;"/>
      <label for="label">Compact # Formatting</label>
    </div>

    <div>
      <div style="margin-top: 20px">Editor</div>
      <SelectButton v-model="modelEditor" :options="modelEditorOptions"/>
    </div>

    <div v-if="selectedWidget.editorType === 'time'">
      <div style="margin-top: 20px">Format</div>
      <Dropdown v-model="timeFormat" :options="timeFormatOptions"  />

      <div style="margin-top: 20px">Save Time As</div>
      <SelectButton v-model="saveAsTime" :options="saveTimeAsOptions"/>

    </div>


    <div v-if="selectedWidget.hookId === 'meta-currency'">
      <div style="margin-top: 20px">Currencies</div>
      <MultiSelect filter v-model="chosenCurrencies" :options="formattedCurrencies" placeholder="Select Currencies"
                    :inputStyle="{ width: '120px' }" option-label="label" option-value="value" style="width: 170px; margin-bottom: 15px;" >
      <template #option="slotProps">
        <i :class="slotProps.option.icon"></i>  <span>{{ slotProps.option.label }}</span>  </template>
    </MultiSelect>
    </div>

    <div v-if="selectedWidget.hookId === 'meta-currency'">
      <div style="margin-top: 20px">Currency Display Type</div>
      <SelectButton v-model="currencyType" :options="currencyTypeOptions"/>
    </div>

    <div v-if="activeSubtype === 'choice' && selectedWidget.editorType === 'button'">
      <div class="style-section" style="display: flex; align-items: center; margin-top: 20px">
        <span class="label-long">Button Color</span>
        <div style="width: 100px; display: inline-block">
          <ColorButton @click="buttonColorPickerVisible.toggle($event)" :color="choiceButtonColor" style="flex: 3"  />
          <OverlayPanel ref="buttonColorPickerVisible">
            <ColorPicker v-model="choiceButtonColor"
                         @edit-theme="$refs.buttonColorPickerVisible.toggle(false); themeDialogVisible = true"
            />
          </OverlayPanel>
        </div>
      </div>

      <div class="style-section" style="display: flex; align-items: center; margin-top: 20px">
        <span class="label">Button Text</span>
        <InputText placeholder="Enter Button Text" inputId="choiceButtonText" v-model="choiceButtonText" style="width:200px;margin-left: 20px"/>
      </div>

    </div>

    <Checkbox v-model="selectedWidget.placeholder" :binary="true" style="margin-right: 10px;margin-top: 10px;"/>
    <label for="label">Placeholder</label>

    <div class="style-section" style="display: flex; align-items: center; margin-top: 20px">
      <span class="label-long">Placeholder Color</span>
      <div style="width: 200px; display: inline-block">
        <ColorButton @click="colorPickerVisible.toggle($event)" :color="placeholderColor" style="flex: 3"  />
        <OverlayPanel ref="colorPickerVisible">
          <ColorPicker v-model="placeholderColor"
                       @edit-theme="$refs.colorPickerVisible.toggle(false); themeDialogVisible = true"
          />
        </OverlayPanel>
      </div>
    </div>

    <div class="style-section" style="display: flex; align-items: center; margin-top: 20px" v-if="modelEditor === 'Slider'">
      <span class="label-long">Slider Color</span>
      <div style="width: 200px; display: inline-block">
        <ColorButton @click="colorPickerVisible.toggle($event)" :color="sliderColor" style="flex: 2"  />
        <OverlayPanel ref="colorPickerVisible">
          <ColorPicker v-model="sliderColor"
                       @edit-theme="$refs.colorPickerVisible.toggle(false); themeDialogVisible = true"
          />
        </OverlayPanel>
      </div>
    </div>

    <div class="style-row" v-if="modelEditor === 'Checkbox' || modelEditor === 'Switch' || modelEditor === 'Select'">
      <div style="width: 175px">{{ modelEditor }} Background Color</div>
      <ColorButton :width="`100px`" :color="editorBackgroundColor ?? '#000'" @click="$refs.colorPickerVisible.toggle($event)" style="width: 120px;margin-left: 10px;"/>
      <OverlayPanel ref="colorPickerVisible">
        <ColorPicker v-model="editorBackgroundColor"/>
      </OverlayPanel>
    </div>

    <div style="margin-top: 20px; ">Icon Position</div>
    <SelectButton style="margin-bottom: 20px" v-model="iconPosition" :options="positionOptions"/>

    <div v-if="selectedWidget['iconPosition'] != 'none'">
      <div style="margin-top: 20px; ">Icons</div>
      <SelectButton
          v-model="imageUrl"
          :options="hookId ? elementIcons : defaultIcons"
          :disabled="!hookId"

      >
        <template #option="slotProps">
          <Skeleton
              v-if="selectedWidget.fetchingIcons"
              width="48px"
              height="48px"
              borderRadius="4px"
          />
          <i v-else-if="!hookId" :class="slotProps.option.icon"></i>
          <img :style="{ ...filterStyle }" v-else :src="slotProps.option" alt="icon" style="width: 48px; height: 48px;" />
        </template>
      </SelectButton>


        <div style="width: 100px; display: inline-block">
          <ColorButton @click="vectorPickerVisible.toggle($event)" :color="vectorColor" style="flex: 3" />
          <OverlayPanel ref="vectorPickerVisible">
            <ColorPicker v-model="vectorColor" />
          </OverlayPanel>
        </div>

    </div>

    <div class="style-row">
      <Checkbox v-model="aiButton" :binary="true" style="margin-right: 10px;"/>
      Add AI Chat Button
    </div>

    <div class="style-row" v-if="aiButton && selectedWidget.type === 'model_data'">
      <Checkbox v-model="aiButtonIncludeFormulas" :binary="true" style="margin-right: 10px;"/>
      Include Value Model Formulas in Summary
    </div>

    <Idot/>

  </div>
  <component :is="currentPanelComponent"></component>
</template>

<script setup lang="ts">

import SelectButton from "primevue/selectbutton";
import {ElementTypes, WidgetTypes} from "@/types/slides";
import WidgetInputNumberPanel
  from "@/views/Editor/Toolbar/ElementStylePanel/WidgetStylePanel/InputNumberStylePanel.vue";
import TextStylePanel from "@/views/Editor/Toolbar/ElementStylePanel/TextStylePanel.vue";
import HtmlStylePanel from "@/views/Editor/Toolbar/ElementStylePanel/HtmlStylePanel.vue";
import ImageStylePanel from "@/views/Editor/Toolbar/ElementStylePanel/ImageStylePanel.vue";
import ShapeStylePanel from "@/views/Editor/Toolbar/ElementStylePanel/ShapeStylePanel.vue";
import LineStylePanel from "@/views/Editor/Toolbar/ElementStylePanel/LineStylePanel.vue";
import ChartStylePanel from "@/views/Editor/Toolbar/ElementStylePanel/ChartStylePanel/index.vue";
import TableStylePanel from "@/views/Editor/Toolbar/ElementStylePanel/TableStylePanel.vue";
import LatexStylePanel from "@/views/Editor/Toolbar/ElementStylePanel/LatexStylePanel.vue";
import VideoStylePanel from "@/views/Editor/Toolbar/ElementStylePanel/VideoStylePanel.vue";
import AudioStylePanel from "@/views/Editor/Toolbar/ElementStylePanel/AudioStylePanel.vue";
import WidgetCsvImport from "@/views/Editor/CanvasTool/components/CsvImportSettings.vue";
import WidgetButtonPanel from "@/views/Editor/Toolbar/ElementStylePanel/WidgetStylePanel/ButtonStylePanel.vue";
import WidgetImagePanel from "@/views/Editor/Toolbar/ElementStylePanel/WidgetStylePanel/ImageStylePanel.vue";
import {computed, ref, watch, onMounted} from "vue";
import {storeToRefs} from "pinia";
import {useGivingTreeStore, useMainStore, useSlidesStore, useWidgetStore} from "@/store";
import Idot from "@/views/Editor/Toolbar/common/IdotStyle.vue";
import tinycolor from "tinycolor2";
import {hexToCSSFilter} from "hex-to-css-filter";
import ColorPicker from "@/components/ColorPicker/index.vue";
import ColorButton from "@/views/Editor/Toolbar/common/ColorButton.vue";

const {activeType, activeSubtype} = storeToRefs(useWidgetStore())
const {activeElementIdList, activeElementList, activeGroupElementId, themeDialogVisible} = storeToRefs(useMainStore())
const widgetStore = useWidgetStore()
const {selectedWidget} = storeToRefs(widgetStore)
const givingTreeStore = useGivingTreeStore()

const hookId = computed(() => selectedWidget.value.hookId)
const imageUrl = computed({
  get() {
    return selectedWidget.value.imageUrl;
  },
  set(value) {
    selectedWidget.value.imageUrl = value;
  }
});
const elementIcons = computed(() => selectedWidget.value.icons ?? null)
const filterStyle = computed(() => {
  const style = selectedWidget.value?.style ?? {};
  return {
    filter: style.filter
  };
});

const colorPickerVisible = ref()
const defaultIcons = ref([{ icon: 'pi pi-ban', value: 'none' }]);

const buttonColorPickerVisible = ref()
const choiceButtonColor = computed({
  get: () => selectedWidget.value?.style?.choiceButtonColor ?? 'transparent',
  set: val => selectedWidget.value && (selectedWidget.value.style.choiceButtonColor = val)
})

const choiceButtonText = computed({
  get: () => selectedWidget.value?.choiceButtonText ?? '',
  set: val => selectedWidget.value && (selectedWidget.value.choiceButtonText = val)
})

const placeholderColor = computed({
  get: () => selectedWidget.value?.style?.placeholderColor ?? 'transparent',
  set: val => selectedWidget.value && (selectedWidget.value.style.placeholderColor = val)
})

const vectorPickerVisible = ref()
const vectorHexHold = computed(() => selectedWidget.value.style.hex ?? '')
const vectorColor = computed({
  get: () => vectorHexHold.value ?? '',
  set: val => {
    const realHex = tinycolor(val).toHexString()
    selectedWidget.value.style.hex = realHex
    const cssFilter = hexToCSSFilter(realHex)
    const newFilter = cssFilter.filter.replace(/;$/, '')
    selectedWidget.value && (selectedWidget.value.style.filter = newFilter)
  }
})

const textAreaRows = computed({
  get: () => selectedWidget.value.textAreaRowHeight ?? 1,
  set: val => {
    selectedWidget.value.textAreaRowHeight = val
  }
})

const chosenCurrencies = computed({
  get: () => selectedWidget.value?.currencies ?? [{
    code:'USD',
    name: new Intl.DisplayNames(['en-US'], { type: 'currency' }).of('USD')
  }],
  set: val => {
    selectedWidget.value.currencies = val
  }
})


const currencies = Intl.supportedValuesOf("currency");
const formattedCurrencies = currencies.map(currencyCode => ({
  value: {
    code: currencyCode,
    name: new Intl.DisplayNames(['en-US'], { type: 'currency' }).of(currencyCode)
  },
  label: `${currencyCode} - ${new Intl.DisplayNames(['en-US'], { type: 'currency' }).of(currencyCode)}`
}));



const currencyTypeOptions = ['Code', 'Name']
const timeFormatOptions = ['HH:mm ss', 'H:mm ss', 'mm ss', 'm ss'] // these aren't working  'HH:mm',
const saveTimeAsOptions = ['Hours', 'Minutes', 'Seconds']

const timeFormat = computed({
  get: () => selectedWidget.value?.timeFormat ?? 'HH:mm:ss',
  set: val => {
    selectedWidget.value.timeFormat = val
  }
})

const saveAsTime = computed({
  get: () => selectedWidget.value?.saveTimeAs ?? 'Minutes',
  set: val => {
    selectedWidget.value.saveTimeAs = val
  }
})

const currencyType = computed({
  get: () => selectedWidget.value?.currencyType ?? 'Code',
  set: val => {
    selectedWidget.value.currencyType = val
  }
})

const widgetPanelMap = {
  [WidgetTypes.INPUT_NUMBER]: WidgetInputNumberPanel,
  [WidgetTypes.CSV]: WidgetCsvImport,
  [WidgetTypes.BUTTON]: WidgetButtonPanel,
  [WidgetTypes.IMAGE]: WidgetImagePanel,
}

const panelMap = {
  [ElementTypes.TEXT]: TextStylePanel,
  [ElementTypes.HTML]: HtmlStylePanel,
  [ElementTypes.IMAGE]: ImageStylePanel,
  [ElementTypes.SHAPE]: ShapeStylePanel,
  [ElementTypes.LINE]: LineStylePanel,
  [ElementTypes.CHART]: ChartStylePanel,
  [ElementTypes.TABLE]: TableStylePanel,
  [ElementTypes.LATEX]: LatexStylePanel,
  [ElementTypes.VIDEO]: VideoStylePanel,
  [ElementTypes.AUDIO]: AudioStylePanel,
}

const positionOptions = ref([
  'Top',
  'Bottom',
  'Left',
  'Right',
  'None'
])

const createPositionComputed = (positionKey) => {
  return computed({
    get() {
      const value = selectedWidget.value?.[positionKey] || 'top';
      switch (value) {
        case 'top': return "Top";
        case 'bottom': return "Bottom";
        case 'left': return "Left";
        case 'right': return "Right";
        case 'none': return "None";
        default: return "Top";
      }
    },
    set(value) {
      switch (value) {
        case 'Top': selectedWidget.value[positionKey] = 'top'; break;
        case 'Bottom': selectedWidget.value[positionKey] = 'bottom'; break;
        case 'Left': selectedWidget.value[positionKey] = 'left'; break;
        case 'Right': selectedWidget.value[positionKey] = 'right'; break;
        case 'None': selectedWidget.value[positionKey] = 'none'; break;
      }
    }
  });
};

const labelPosition = createPositionComputed('labelPosition');
const iconPosition = createPositionComputed('iconPosition');



const currentPanelComponent = computed(() => {
  if (activeElementIdList.value.length > 1) {
    // if (!activeGroupElementId.value) return MultiStylePanel

    const activeGroupElement = activeElementList.value.find(item => item.id === activeGroupElementId.value)
    return activeGroupElement ? (panelMap[activeGroupElement.type] || null) : null
  }

  if (activeType.value === 'model_data') {

    if (activeSubtype.value === 'input_number') return widgetPanelMap['inputNumber']
    if (activeSubtype.value === 'choice') return widgetPanelMap['choice']
    if (activeSubtype.value === 'model_text') return widgetPanelMap['modelText']
    if (activeSubtype.value === 'out_text') return widgetPanelMap['outText']
  }

  if (activeType.value === 'button') return widgetPanelMap['button']
  if (activeType.value === 'csv_selector') return widgetPanelMap['csv']
  if (activeType.value === 'image') return widgetPanelMap['image']
  if (activeType.value === 'chart') return panelMap['chart']
  if (activeType.value === 'table') return panelMap['table']

})

const modelEditorOptions = computed(() => filteredModelEditorOptions(givingTreeStore.getWidgetValue(hookId.value)));
const modelFieldOptions = computed(() => filteredModelFieldOptions(givingTreeStore.getWidgetValue(hookId.value)));



const modelFieldOptionsMap = {
  'value-driver': ['Value', 'Message', 'Notes', 'None'],
  'price-component': ['Value', 'Message', 'Notes', 'None'],
  'meta': ['Value', 'None'],
  'globals': ['Value', 'None'],
  'feature': ['Value', 'Notes', 'None'],
  'benefit': ['Value', 'Notes', 'None'],
};

const filteredModelFieldOptions = (value) => {
  return modelFieldOptionsMap[value?.type] || ['Value', 'Notes', 'Source', 'None'];
};


const modelField = computed({
  get() {
    const fieldType = selectedWidget.value?.fieldType ?? 'Value';
    const fieldTypeMap = {
      value: 'Value',
      message: 'Message',
      notes: 'Notes',
      source: 'Source',
      none: 'None'
    };


    return fieldTypeMap[fieldType] || modelFieldOptions.value[0]
  },
  set(val) {
    const fieldTypeMap = {
      Value: 'value',
      Message: 'message',
      Notes: 'notes',
      Source: 'source',
      None: 'none'
    };

    selectedWidget.value.fieldType = fieldTypeMap[val];

    if (val === 'None') {
      modelEditor.value = 'None'
    } else {
      modelEditor.value = modelEditorOptions.value[0]
    }

  }
});


const filteredModelEditorOptions = (value) => {

  if (modelField.value !== 'Value' || (value?.type === 'meta' && value?.hookId !== 'meta-customer-unit'
      &&  value?.hookId !== 'meta-locale' &&  value?.hookId !== 'meta-currency')) {
    return ['Input', 'Date', 'None']
  }


  if (value?.hookId === 'meta-locale' || value?.hookId === 'meta-currency') return ['Dropdown']


  if (value?.isChoice) {
    return ['Switch', 'Checkbox', 'Button', 'Dropdown', 'Select', 'Read Only']
  }


  if (value?.type === 'value-driver' || value?.type === 'price-component' || value?.readOnly || !value?.hookId) {
    return ['None']
  }

  return [
    'Number',
    'Spinner',
    'Slider',
      'Time',
    'None'
  ]
}


const modelEditor = computed({
  get() {
    const subType = selectedWidget.value?.subType
    const editorType = selectedWidget.value?.editorType


    const subTypeMap = {
      out_text: 'None',
      model_text: (() => {
        switch (editorType) {
          case 'input':
            return 'Input';
          case 'date':
            return 'Date';
          default:
            return 'Input';
        }
      })(),
      input_number: (() => {
        switch (editorType) {
          case 'number':
            return 'Number';
          case 'spinner':
            return 'Spinner';
          case 'time':
            return 'Time';
          default:
            return 'Slider';
        }
      })(),
      choice: (() => {
        switch (editorType) {
          case 'dropdown':
            return 'Dropdown';
          case 'select':
            return 'Select';
          case 'switch':
            return 'Switch';
          case 'readonly':
            return 'Read Only';
          case 'button':
            return 'Button';
          default:
            return 'Checkbox';
        }
      })()
    };

    return subTypeMap[subType]
  },
  set(val) {
    const subTypeMap = {
      None: {subType: 'out_text', editorType: 'none'},
      Input: {subType: 'model_text', editorType: 'input'},
      Date: {subType: 'model_text', editorType: 'date'},
      Time: {subType: 'input_number', editorType: 'time'},
      Number: {subType: 'input_number', editorType: 'number'},
      Slider: {subType: 'input_number', editorType: 'slider'},
      Spinner: {subType: 'input_number', editorType: 'spinner'},
      Dialog: {subType: 'input_number', editorType: 'dialog'},
      Checkbox: {subType: 'choice', editorType: 'checkbox'},
      Select: {subType: 'choice', editorType: 'select'},
      Switch: {subType: 'choice', editorType: 'switch'},
      Dropdown: {subType: 'choice', editorType: 'dropdown'},
      'Read Only': {subType: 'choice', editorType: 'readonly'},
      Button: {subType: 'choice', editorType: 'button'},
    };

    const {subType, editorType} = subTypeMap[val]
    selectedWidget.value.subType = subType
    selectedWidget.value.editorType = editorType
  }
});

const editorBackgroundColor = computed({
  get() {
    return selectedWidget.value?.editorBackgroundColor ?? 'transparent'
  },
  set(val) {
    selectedWidget.value.editorBackgroundColor = val
  }
})

const aiButton = computed({
  get: () => selectedWidget.value?.aiButton ?? false,
  set: val => selectedWidget.value && (selectedWidget.value.aiButton = val)
})

const aiButtonIncludeFormulas = computed({
  get: () => selectedWidget.value?.aiButtonIncludeFormulas ?? false,
  set: val => selectedWidget.value && (selectedWidget.value.aiButtonIncludeFormulas = val)
})

const sliderColor = computed({
  get: () => selectedWidget.value?.sliderColor ?? 'rgb(33, 150, 243)',
  set: val =>selectedWidget.value.sliderColor = val
})

watch(modelEditor, (newVal) => {
  const editorTypeMap = {
    Switch: 'switch',
    Slider: 'slider',
    Select: 'select',
    Time: 'time',
    Dropdown: 'dropdown',
    Checkbox: 'checkbox',
    Spinner: 'spinner',
    'Read Only': 'readonly',
    None: 'none',
    Input: 'input',
    Number: 'number',
    Date: 'date',
    Button: 'button'
  };

  selectedWidget.value.editorType = editorTypeMap[newVal];

});

watch(hookId, (newVal) => {
  const value = givingTreeStore.getWidgetValue(newVal)
  const editorOptions = filteredModelEditorOptions(value)
  const fieldOptions = filteredModelFieldOptions(value)

  // if the value is not available then default to the first one
  if (editorOptions.indexOf(modelEditor.value) === -1) {
    modelEditor.value = editorOptions[0]
  }
  if (fieldOptions.indexOf(modelField.value) === -1) {
    modelField.value = fieldOptions[0]
  }
})

</script>
<style scoped>
.style-row { margin-top: 15px; align-items: center; display: flex  }
span.label-long { display: inline-block; width: 100px }

</style>
